import Vue from 'vue'
import Vuex from 'vuex'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor from 'vuelidate-error-extractor'
import vuelidateErrorDialog from "./components/VuelidateErrorDialog";
import { vuelidate_attributes, vuelidate_messages } from "./_helpers/validators";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { store } from './_store'
import { router } from './_helpers'
import App from './App.vue'
import i18n from './_helpers/i18n'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-pro/css/all.css'
import '@fortawesome/fontawesome-pro/js/all.js'
import 'es6-promise/auto'
import { http } from './_services/http.service'
import * as Resize from './_helpers/iframeResizer.contentWindow.min'
import DisableAutocomplete from 'vue-disable-autocomplete'

require(`./assets/css/${process.env.VUE_APP_CSS}`)
require('./assets/css/common.css')
require('./assets/css/font-awesome.min.css')

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(DisableAutocomplete)
Vue.use(Vuelidate)
/* Load messages from helpers/validators for now. Remember: This function has support for i18n via i18nAttributes and i18n*/
Vue.use(VuelidateErrorExtractor, {
  template: vuelidateErrorDialog,
  messages: vuelidate_messages,
  attributes: vuelidate_attributes
})
Vue.use(Resize)

Vue.prototype.$http = http

const vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
})


vm.$mount('#app')
